import { LoaderFunctionArgs, useLoaderData } from "react-router";
import { organizationContext } from "../infrastructure/organization/OrganizationContext";
import { certificatesApi } from "../Certificate/certificatesApi";
import { clientsApi } from "../Client/clientsApi";

export interface HomeStats {
  clientCount: number;
  certificateTotal: number;
  certificateActive: number;
  certificateRevoked: number;
}

export const homeLoader = async ({
  context,
}: LoaderFunctionArgs): Promise<HomeStats> => {
  const organization = context.get(organizationContext);
  const [clients, certificates] = await Promise.all([
    clientsApi(organization).listClients(),
    certificatesApi(organization).listCertificates(),
  ]);

  const certificateActive = certificates.filter(
    (c) => !c.certificate.revoked,
  ).length;

  return {
    clientCount: clients.length,
    certificateTotal: certificates.length,
    certificateActive,
    certificateRevoked: certificates.length - certificateActive,
  };
};

export const useHomeStats = (): HomeStats => useLoaderData<HomeStats>();
